module.exports = __webpack_public_path__ + "static/media/Bottomzigzag.59102425.svg";